import MainCtrl from './main.controller';
import ngEnter from './directives/ng-enter';
import Spinner from './directives/spinner';
import RmSwitch from './directives/rm-switch';
import rmRecipients from './directives/rm-recipients';
import rmCopy from './directives/rm-copy';
import rmFileRead from './directives/rm-file-read';
import scrollSticky from './directives/scroll-sticky';
import ruleProgressBar from "./directives/rule-progress-bar";
import rmDatepicker from "./directives/rm-datepicker";
import rmTimePicker from "./directives/rm-timepicker";
import rmDateTimePicker from './directives/rm-datetimepicker';
import languageSelect from "./directives/language";
import accessControl from "./directives/access-control";
import informationBox from "./directives/information-box";
import imageInformation from "./directives/image-information";
import scrollFollow from "./directives/scroll-follow";
import slideRight from "./directives/animations/slide-right";
import slideLeft from "./directives/animations/slide-left";
import slideUp from "./directives/animations/slide-up";
import slideDown from "./directives/animations/slide-down";
import messageFlowEndpoint from "./directives/message-flow-endpoint";
import selectCloseOnBlur from "./directives/select-close-on-blur";
import onlyIntegers from "./directives/only-integers";
import uiSelectChoiceExtended from "./directives/ui-select-choice-extended";
import slideRightAnimation from "./animations/slide-right";
import slideLeftAnimation from "./animations/slide-left";
import slideUpAnimation from "./animations/slide-up";
import slideDownAnimation from "./animations/slide-down";
import EventListener from './services/eventListener';
import Events from './services/Events';
import PageMenu from './services/pageMenu';
import Rest from './services/Rest';
import SideMenu from './services/sideMenu';
import Translate from './services/translate';
import Language from './services/language';
import CurrentAccount from './services/CurrentAccount';
import ProgressBar from "./services/progressBar";
import TimePrinter from "./services/timePrinter";
import SweetAlert from "./services/sweetAlert";
import HelpScout from "./services/HelpScout";
import StringUtils from "./services/stringUtils";
import routing from './main.routes';
import wrapIn from './filters/wrap-in';
import toDate from './filters/to-date';
import b64encode from './filters/base64-encode';
import b64decode from './filters/base64-decode';
import toSpokenDate from './filters/to-spoken-date';
import capitalize from './filters/capitalize';
import zeroPaddedTime from './filters/zero-padded-time';
import unsafeHtml from './filters/unsafe-html';
import range from './filters/range';
import getNumberedNameFilter from "./filters/numbered-name";
import Fanout from "./providers/provider";
import uirouter from 'angular-ui-router';
import 'angular-cookies';

export default angular.module('app.main', [uirouter])
    .config(routing)
    .controller('MainCtrl', MainCtrl)
    .directive('ngEnter', () => new ngEnter)
    .directive('spinner', ($rootScope) => new Spinner)
    .directive('rmSwitch', () => new RmSwitch)
    .directive('rmRecipients', () => new rmRecipients)
    .directive('rmFileRead', () => new rmFileRead)
    .directive('rmCopy', () => new rmCopy)
    .directive('rmDatepicker', () => new rmDatepicker)
    .directive('rmTimePicker', () => new rmTimePicker)
    .directive('rmDateTimePicker', () => new rmDateTimePicker)
    .directive('scrollSticky', () => new scrollSticky)
    .directive('ruleProgressBar', () => new ruleProgressBar)
    .directive('languageSelect', () => new languageSelect)
    .directive('accessControl', () => new accessControl)
    .directive('informationBox', () => new informationBox)
    .directive('imageInformation', () => new imageInformation)
    .directive('scrollFollow', () => new scrollFollow)
    .directive('slideRight', () => new slideRight)
    .directive('slideLeft', () => new slideLeft)
    .directive('slideUp', () => new slideUp)
    .directive('slideDown', () => new slideDown)
    .directive('messageFlowEndpoint', () => new messageFlowEndpoint)
    .directive('selectCloseOnBlur', () => new selectCloseOnBlur)
    .directive('onlyIntegers', () => new onlyIntegers)
    .directive('uiSelectChoiceExtended', () => new uiSelectChoiceExtended)
    .animation('.slide-right', slideRightAnimation)
    .animation('.slide-left', slideLeftAnimation)
    .animation('.slide-up', slideUpAnimation)
    .animation('.slide-down', slideDownAnimation)
    .service('EventListener', EventListener)
    .service('Events', Events)
    .service('PageMenu', PageMenu)
    .service('Rest', Rest)
    .service('Translate', Translate)
    .service('SideMenu', SideMenu)
    .service('CurrentAccount', CurrentAccount)
    .service('Language', Language)
    .service('ProgressBar', ProgressBar)
    .service('TimePrinter', TimePrinter)
    .service('SweetAlert', SweetAlert)
    .service('StringUtils', StringUtils)
    .service('HelpScout', HelpScout)
    .filter('wrapIn', wrapIn)
    .filter('toDate', toDate)
    .filter('b64decode', b64decode)
    .filter('b64encode', b64encode)
    .filter('toSpokenDate', toSpokenDate)
    .filter('capitalize', capitalize)
    .filter('zeroPaddedTime', zeroPaddedTime)
    .filter('unsafeHtml', unsafeHtml)
    .filter('getNumberedName', getNumberedNameFilter)
    .filter('range', range)
    .provider('Fanout', Fanout)
    .name;
